module.exports = __webpack_public_path__ + "img/dataservice_jcflfws.d2359625.png";